import type { JSX } from 'react';
import React from 'react';
import { DrawApi } from '@apply/api';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { handleAdminError } from '../../../../../../../apps/admin/src/common/functions/handleAdminError';
import { handleAdminSuccess } from '../../../../../../../apps/admin/src/common/functions/handleAdminSuccess';

interface IEmailBorrowerToResubmitButtonProps {
    drawId: number;
    latestDrawHasFunding: boolean;
    applicationInsights: ApplicationInsights;
}

export const EmailBorrowerToResubmitButton = ({
    drawId,
    latestDrawHasFunding,
    applicationInsights,
}: IEmailBorrowerToResubmitButtonProps): JSX.Element => {
    const drawApi = new DrawApi.DrawApi(applicationInsights);
    const borrowerSignOffConfirmMessage = 'Are you sure you want to send the Funded Amount to the Borrower for signature?';

    const emailBorrowerToResubmit = async (drawId: number) => {
        if (window.confirm(borrowerSignOffConfirmMessage) === true) {
            try {
                const response = await drawApi.resignBorrowerSubmission(drawId);
                if (response.statusCode !== 200) {
                    throw new Error('An unexpected error has occurred. Please try again.');
                }
                handleAdminSuccess('Your request to resign has been sent sucessfully');
            } catch (ex: any) {
                handleAdminError(ex, ex.message);
            }
        }
    };

    const titleText = latestDrawHasFunding
        ? 'Email borrower to sign off on changes.'
        : 'Please enter the potential draw amount in the Funded column to be sent to the borrower.';

    return (
        <button
            type='button'
            onClick={() => emailBorrowerToResubmit(drawId)}
            className='button hollow'
            style={{ marginLeft: 5 }}
            title={titleText}
            disabled={!latestDrawHasFunding}
        >
            <FontAwesomeIcon icon={faEnvelope} />
        </button>
    );
};
